// extracted by mini-css-extract-plugin
module.exports = {"container":"Heatmap_container__HIv9R","image":"Heatmap_image__3D6z1"};